import { BotImg, ImageWrapper } from '~components/BotAvatar/BotAvatar.styles';
import type { TMedia } from '~constants/media';
import { ImageRenderer } from '~shared/ui/molecules';

type TBotAvatarProps = {
	item?: TMedia[];
	fallback?: string;
	size?: number;
};
export const BotAvatar: React.FC<TBotAvatarProps> = ({
	item,
	fallback = '/img/botPlaceholder.webp',
	size = 48,
}) => {
	return (
		<ImageWrapper size={size}>
			<ImageRenderer
				className={BotImg}
				item={item}
				fallback={fallback}
				alt=""
				width={size}
				height={size}
			/>
		</ImageWrapper>
	);
};
